var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4065 3.75H35.9198L23.8748 17.5167L38.0448 36.25H26.9498L18.2598 24.8883L8.31651 36.25H2.79984L15.6832 21.525L2.08984 3.75H13.4665L21.3215 14.135L30.4065 3.75ZM28.4715 32.95H31.5265L11.8065 6.87667H8.52818L28.4715 32.95Z",
    fill: "#currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/xLogo.d52d58898dd586a246a7e1e39353ccde.svg";
export { ForwardRef as ReactComponent };